<div *ngIf="data" #copyEl (click)="copy()" [ngClass]="{'dark': darkMode}"></div>
